export default "__VITE_ASSET__oeHu_K91__"